import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { APIProvider } from '@vis.gl/react-google-maps';

import Home from './views/Home';
import NavBar from './components/NavBar';
import MesaDeRegalos from './views/MesaDeRegalos';
import ThanksModal from './components/Thanks';

const App: React.FC = () => (
  <APIProvider
    apiKey={process.env.REACT_APP_GOOGLE_API_KEY || ''}
    onLoad={() => console.log('Maps API has loaded.')}
  >
    <div className="App">
      <Router>
        <ThanksModal />
        <NavBar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/mesa-de-regalos" element={<MesaDeRegalos />} />
        </Routes>
      </Router>
    </div>
  </APIProvider>
);

export default App;
